import QuestionStorage from './QuestionStorage';

class QuestionStorageBuilder {
	static buildForFirstQuestion({questionsOwnerPageId, totalQuestions, firstQuestion, showCloseButton, mandatoryPrequel, prequelId, redirectSourcePageId = null}) {
		let questionStorage = QuestionStorageBuilder.buildFromStorageData(questionsOwnerPageId, redirectSourcePageId);

		if (!questionStorage.isInit()) {
			questionStorage = new QuestionStorage();
		}

		questionStorage.pageId = questionsOwnerPageId;
		questionStorage.questionsOwnerPageId = questionsOwnerPageId;
		questionStorage.totalQuestions = totalQuestions;
		questionStorage.question = firstQuestion;
		questionStorage.showCloseButton = showCloseButton;
		questionStorage.mandatoryPrequel = mandatoryPrequel;
		questionStorage.prequelId = prequelId;

		questionStorage.saveToContainer();

		return questionStorage;
	}

	/**
	 * @param {number} pageId
	 * @param {QuestionStorage} questionStorageToGetDataFrom
	 * @param {null|string|boolean} question
	 * @return {QuestionStorage}
	 */
	static buildByPageIdAndDataForQuestion(pageId, questionStorageToGetDataFrom, question) {
		const questionStorage = new QuestionStorage();

		questionStorage.pageId = pageId;
		questionStorage.questionsOwnerPageId = questionStorageToGetDataFrom.questionsOwnerPageId;
		questionStorage.totalQuestions = questionStorageToGetDataFrom.totalQuestions;
		questionStorage.addFilters(questionStorageToGetDataFrom.filters);
		questionStorage.prevQuestions = questionStorageToGetDataFrom.prevQuestions;
		questionStorage.question = question;

		questionStorage.saveToContainer();

		return questionStorage;
	}

	static buildFromStorageData(pageId, redirectSourcePageId = null, saveToContainer = false) {
		const questionStorage = new QuestionStorage();
		questionStorage.redirectSourcePageId = redirectSourcePageId;
		questionStorage.initFromStorage(pageId);

		if (saveToContainer) {
			questionStorage.saveToContainer();
		}

		return questionStorage;
	}
}

export default QuestionStorageBuilder;
